export interface IOperativeStandardsByTripDefSchema {
    tripDefinition: string | null;
    settings: {
        arrivalToleranceTime?: string | null;
        normalLoadTime?: string | null;
        normalUnloadTime?: string | null;
        emptyTripGoal?: number | null;
        standardLoadTime?: string | null;
        standardUnloadTime?: string | null;
        maxDailyDrivingTime?: string | null;
        maxDrivingTime?: string | null;
        restingTime?: string | null;
        drivingTimeWindow?: string | null;
    };
}
